// extracted by mini-css-extract-plugin
export default {"wrapper":"Countdown_wrapper__j1uxM","show":"Countdown_show__2CRRx","animate":"Countdown_animate__bHedI","zoomFade":"Countdown_zoomFade__F8yfO"};